import { useGlobalSearchParams } from 'expo-router'

import { Stack } from '@/src/elements/navigation/Stack'
import { Protected } from '@/src/features/auth/ui/components/Protected'
import { DesktopMessagesScreenLayout } from '@/src/features/message/ui/layouts/DesktopMessagesScreenLayout'
import { useDimensions } from '@/src/general/hooks/useDimensions'

export default function () {
  const { xs } = useDimensions()
  const params = useGlobalSearchParams()

  if (xs)
    return (
      <Protected searchParams={params}>
        <Stack screenOptions={{ headerShown: false }} />
      </Protected>
    )

  return <DesktopMessagesScreenLayout />
}
